// The warm studio sweep as a plain CSS gradient — the Stage's amber-gold backdrop
// with NO three.js, so it's safe to import into the entry bundle (ADR-0041 §7:
// the landing + entry shell pull zero three; see [[landing_three_via_stagehost_modulepreload]]).
//
// Two jobs, both "never a white panel":
//  1. The Suspense fallback while the lazy StageHost chunk (all of three/drei/
//     postprocessing) downloads on a cold load — without it, <main> is transparent
//     and the white page shows through until the chunk evaluates (the white-screen
//     bug on /upload).
//  2. Painted UNDER the canvas inside StageHost, it fills the gap before the WebGL
//     canvas draws its first frame (and is the no-WebGL / context-loss fallback).
//
// Matched to what the CANVAS ACTUALLY RENDERS for the EMPTY stage, not to the raw
// config hues. The first canvas frame on every cold load — /upload AND /preview
// (before the pillow assets resolve) — is the empty warm front door
// (EMPTY_STAGE_WARMTH, operator sign-off variant "B"): a warm-tan glow, darker
// warm-brown at the top/edges. The previous fallback used the RAW config amber-gold
// (a vivid #e0a559 glow) which then "collapsed" to the tone-mapped render the instant
// the canvas painted (operator report: "warm colour flashes, then goes flat"); a
// later revision matched it to the muted PRE-warm render. These stops are sampled
// from the live warm-B render (/shot?fixture=empty) so the hand-off is seamless —
// the canvas paints over an image of itself. (On a context-loss fallback over a
// settled cushion the muted with-pillow field differs slightly, but that recovery
// path is rare and still reads as the same warm sweep, never white.)
//
// RE-SAMPLED 2026-07-15 (operator "cream → yellow pop" report): the empty-stage
// render brightened + goldened since the last sample — poolColor #ffc774 → #ffdca8
// (#216) and the CS-2 matte pass (#266) — so the stale muted-tan stops (#bd957a
// centre) no longer matched the render and the hand-off flashed. Re-sampled from
// /shot?fixture=empty at 1280×960: centre/pool/field are a near-flat warm gold
// (~#d7b96e), falling off through the edge (~#bea360) to the vignetted corners
// (~#665630). NOTE: this must be re-sampled whenever stage-config's backdrop/
// EMPTY_STAGE_WARMTH/tone changes — it has drifted 3× (a derived-from-config
// fallback is the standing follow-up).
export function StageSurround() {
  return (
    <div
      className="absolute inset-0"
      aria-hidden="true"
      style={{
        background:
          "radial-gradient(100% 90% at 50% 46%, #d7b96e 0%, #d4b66c 40%, #b7975a 70%, #665630 100%)",
      }}
    />
  );
}

export default StageSurround;
